import config from '../config'
import http from '../http'

export default{
    saveTemuAuthInfo:async function(payload,userId) {
        const res = await http({
                url: config.TEMU_SAVETEMUAUTHINFO+'?userId='+userId,
                method: 'post',
                data:payload,
            })
        return res.data
    },
    getTemuAuthInfo:async function(payload) {
        const res = await http({
                url: config.TEMU_GETTEMUAUTHINFO,
                method: 'post',
                data:payload,
                headers:{
                    'Content-Type': 'multipart/form-data',
                }
            })
        return res.data
    },
    updateTemuAuthInfo:async function(payload) {
        const res = await http({
                url: config.TEMU_UPDATETEMUAUTHINFO,
                method: 'post',
                data:payload
            })
        return res.data
    },
    getTemuUserInfo:async function(payload) {
        const res = await http({
                url: config.TEMU_GETTEMUUSERINFO,
                method: 'post',
                data:payload
            })
        return res.data
    },
    deleteTemuAuth:async function(payload,userId) {
        const res = await http({
                url: config.TEMU_DELETETEMUAUTH+'?userId='+userId,
                method: 'post',
                data:payload
            })
        return res.data
    },
}